import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Off the route | Olive Oil Trails';
  }, []);

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-6">
      <div className="max-w-xl text-center space-y-6">
        <Compass className="mx-auto text-accent" size={48} />
        <p className="text-[11px] uppercase tracking-widest text-ink-light font-bold">404</p>
        <h1 className="text-4xl md:text-5xl font-serif text-ink leading-[1.1]">
          You drifted off the olive route.
        </h1>
        <p className="text-ink-light leading-relaxed">
          The page you were looking for is not in this guide. Most wrong turns should land back on the map.
        </p>
        <div className="pt-2">
          <Link to="/" className="btn-minimal inline-flex items-center gap-2">
            <ArrowLeft size={14} /> Back to the route
          </Link>
        </div>
      </div>
    </div>
  );
}
